import type { WebWidgetModel } from '@web/types';
import type { MapWidgetData } from '@web/widgets/map/type/map-widget.type';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { MapStyle } from '@web/widgets/map/type/map-widget.type';

import { MapViewComponent } from '@web/widgets/map/components/map-view/map-view.component';
import { MapControlComponent } from '@web/widgets/map/components/map-control/map-control.component';
import { defaultMapItem } from '@web/widgets/map/model/default-address';

// DEFAULT COMPONENT SETTINGS

const mapData: MapWidgetData = {
    apiKey: null,
    addresses: [defaultMapItem],
    center: defaultMapItem.position,
    tempCenter: null,
    zoom: 15,
    mapStyle: MapStyle.Default,
};
// END DEFAULT SETTINGS

export const mapWidgetModel: WebWidgetModel = {
    componentView: MapViewComponent,
    componentControl: MapControlComponent,
    name: Widgets.MAP,
    label: 'widget_map_label',
    data: mapData,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
};
